// deno-fmt-ignore-file
export function FromBase(context, type) {
    return type.Create();
}
